export const baseApi = process.env.NODE_ENV === 'production' ? 'https://apis.okgo.co.id/' : 'https://apis.okgo.co.id/';

// export const baseApi = process.env.NODE_ENV === 'production' ? 'http://localhost:6200/' : 'http://localhost:6200/';

export const imageApi = 'https://apis.okgo.co.id/image/';
export const videoApi = 'https://apis.okgo.co.id/video/';
export const secretKeyStorage = '00kg008921dsmQwXG0004560176cbF190ME';
